import { cn } from "@/lib/utils";

export interface BetaBadgeProps {
  className?: string;
  size?: "xs" | "sm";
}

export function BetaBadge({ className, size = "xs" }: BetaBadgeProps) {
  const sizeClasses =
    size === "xs"
      ? "h-[16px] px-1.5 text-[9px]"
      : "h-[18px] px-2 text-[10px]";

  return (
    <span
      role="status"
      aria-label="Sistema em versão beta"
      className={cn(
        "relative inline-flex items-center justify-center overflow-hidden",
        "rounded-[5px] font-bold uppercase tracking-[0.16em]",
        "text-primary",
        "bg-primary/10 dark:bg-primary/15",
        "ring-1 ring-inset ring-primary/30 dark:ring-primary/40",
        "shadow-[0_0_0_1px_hsl(var(--primary)/0.05),0_1px_8px_-2px_hsl(var(--primary)/0.35)]",
        sizeClasses,
        className,
      )}
    >
      <span className="relative z-[1] leading-none">BETA</span>
      <span
        aria-hidden="true"
        className={cn(
          "pointer-events-none absolute inset-y-0 -left-full w-1/2",
          "bg-gradient-to-r from-transparent via-primary/40 to-transparent",
          "animate-shimmer",
        )}
      />
    </span>
  );
}
